import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg     from "../../../asset/images/power&surveillance/power-plus/hero-bg.webp";
import HeroMobileImg from "../../../asset/images/power&surveillance/power-plus/hero-bg-mobile.webp";
import PowerPlusImg  from "../../../asset/images/power&surveillance/power-plus/power-plus.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pp { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .pp-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .pp-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .pp-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .pp-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .pp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .pp-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .pp-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .pp-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .pp-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .pp-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .pp-subnav-link.pp-active { font-weight: 500; }
  .pp-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .pp-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .pp-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute */
  .pp-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .pp-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .pp-subnav-dropdown-item:last-child { border-bottom: none; }
  .pp-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .pp-subnav-dropdown-item.pp-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .pp-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .pp-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .pp-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .pp-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .pp-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .pp-sidebar-overlay.open { display: block; }
  .pp-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .pp-sidebar.open { transform: translateX(0); }
  .pp-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .pp-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .pp-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pp-sidebar-nav { flex: 1; overflow-y: auto; }
  .pp-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .pp-sidebar-row:hover { background: #fafafa; }
  .pp-sidebar-row.active { color: #000000; font-weight: 400; }
  .pp-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .pp-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .pp-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .pp-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .pp-sidebar-subitem:last-child { }
  .pp-sidebar-subitem:hover { background: #fafafa; }
  .pp-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .pp-breadcrumb { padding: 60px 0 0 0; }
  .pp-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .pp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .pp-bc-item:hover { color: #EB2019; }
  .pp-bc-item.active { color: #202020; }
  .pp-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .pp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .pp-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .pp-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .pp-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .pp-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .pp-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .pp-section-content { padding: 80px 0 0 0; }
  .pp-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .pp-content-left { flex: 0 0 766px; }
  .pp-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pp-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pp-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .pp-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .pp-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .pp-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .pp-para + .pp-para { margin-top: 14px; }
  .pp-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .pp-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .pp-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .pp-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .pp-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .pp-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .pp-hero-bg        { display: block; }
    .pp-subnav         { top: 70px; }
    .pp-anchor         { scroll-margin-top: 110px; }
    .pp-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .pp-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .pp-hero              { height: 300px; }
    .pp-hero-content      { padding: 0 32px; }
    .pp-hero-title        { font-size: 26px; }
    .pp-breadcrumb        { padding: 28px 0 0 0; }
    .pp-breadcrumb-inner  { padding: 0 24px; }
    .pp-inner             { padding: 0 24px; }
    .pp-divider           { padding: 0px 32px 0px 32px; }
    .pp-divider:last-child { display: none; }
    .pp-divider-slim      { padding: 20px 24px 0 24px; }
    .pp-section-content   { padding: 40px 0 0 0; }
    .pp-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .pp-content-left      { flex: none; width: 100%; }
    .pp-features-tag      { margin: 24px 0 24px 0; }
    .pp-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .pp-img-col           { min-height: 260px; width: 100%; }
    .pp-img-wrap          { max-height: 450px; }
    .pp-red-title         { font-size: 24px; margin-bottom: 10px; }
    .pp-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .pp-para              { font-size: 14px; }
    .pp-para + .pp-para   { margin-top: 10px; }
    .pp-features-list li  { font-size: 14px; }
    .pp-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .pp-subnav           { display: none; }
    .pp-mobile-bar       { display: flex; height: 46px; }
    .pp-sidebar-header   { height: 46px; }
    .pp-anchor           { scroll-margin-top: 80px; }
    .pp-hero-bg          { display: none; }
    .pp-hero-bg-mobile   { display: block; }
    .pp-hero             { height: 370px; }
    .pp-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .pp-hero-title       { font-size: 22px; }
    .pp-breadcrumb       { padding: 22px 0 0 0; }
    .pp-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .pp-bc-item          { font-size: 14px; }
    .pp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .pp-inner            { padding: 0 16px; }
    .pp-divider          { padding: 0px 16px; }
    .pp-divider-slim     { padding: 30px 16px 0 16px; }
    .pp-section-content  { padding: 60px 0 0 0; }
    .pp-section-content:last-child { padding: 60px 0 0px 0; }
    .pp-divider:last-child { display: none; }
    .pp-content-grid:last-child { margin-bottom: 60px !important; }
    .pp-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .pp-img-wrap         { max-height: 260px; }
    .pp-red-title        { font-size: 20px; margin-bottom: 10px; }
    .pp-subtitle         { font-size: 16px; margin-bottom: 10px; }
    .pp-para             { font-size: 14px; }
    .pp-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, active: true, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",   href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)", href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "pp-product-1",
    title:    "POWER+ SERIES (10 KVA – 500 KVA)",
    subtitle: "Next Generation Modular UPS 1:1/3:1/3:3 Phase PF 0.8",
    paras: [
      '"Power+" is a true online modular Uninterrupted Power Supply system  based on True Online Battery Topology, upgraded from 10kVA-100kVA.  Power+ has maximum safety without transferring the load to bypass  source. Power+ is a next-generation system specially designed with  unmatched reliability, pure power quality and very high electrical  efficiency for critical applications',
    ],
    features: [
      "True Modularity",
      "True Rightsizing",
      "True Green Power",
      "True On-line",
      "Small footprint and lightweight",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: true,
    imgSrc: PowerPlusImg,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="pp-subnav-item">
        <a href={item.href || "#"} className={`pp-subnav-link${item.active ? " pp-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="pp-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`pp-subnav-link${item.active ? " pp-active" : ""}`}>
        {item.label}
        <span className={`pp-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="pp-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`pp-subnav-dropdown-item${child.active ? " pp-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`pp-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`pp-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`pp-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="pp-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`pp-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function PowerPlusSeries() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="pp">
        <section className="pp-hero">
          <img className="pp-hero-bg" src={HeroBgImg} alt="" />
          <img className="pp-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="pp-hero-content">
            <h1 className="pp-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .pp */}
      <nav className="pp-subnav" aria-label="Product categories">
        <div className="pp-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .pp */}
      <div className="pp-mobile-bar">
        <span className="pp-mobile-bar-title">Power+ Series</span>
        <button className="pp-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`pp-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`pp-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="pp-sidebar-header">
          <span className="pp-sidebar-header-title">Power+ Series</span>
          <button className="pp-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="pp-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="pp">
        <nav className="pp-breadcrumb" aria-label="Breadcrumb">
          <div className="pp-breadcrumb-inner">
            <a href="/" className="pp-bc-item">Home</a>
            <span className="pp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="pp-bc-item">Business</a>
            <span className="pp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="pp-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="pp-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="pp-anchor" />
            <section className="pp-section-content">
              <div className="pp-inner">
                <div
                  className="pp-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="pp-content-left">
                    <h2 className="pp-red-title">{product.title}</h2>
                    <h3 className="pp-subtitle">{product.subtitle}</h3>
                    {product.paras.map((p, i) => (
                      <p key={i} className="pp-para">{p}</p>
                    ))}
                    <div className="pp-features-tag">
                      <div className="pp-features-tag-bar" />
                      <span className="pp-features-tag-text">Features</span>
                    </div>
                    <ul className="pp-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="pp-img-col">
                    <div className="pp-img-wrap">
                      {product.imgSrc &&
                        <img className="pp-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="pp-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}